import React from 'react';
import {
  Container,
  Grid,
  makeStyles,
  Button,
  Box
} from '@material-ui/core';
import {useNavigate } from 'react-router-dom';
import Page from 'src/components/Page';
import Profile from './Profile';
import ProfileDetails from './ProfileDetails';
import MyContext from 'src/MyContext.js';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Account = (data) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <MyContext.Consumer>{context => (
    <Page
      className={classes.root}
      title="Account"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={4}
            md={6}
            xs={12}
          >
            <Profile userInfo={context.userInfo} warehouseUserInfo={context.warehouseUserInfo}/>
          </Grid>
          <Grid
            item
            lg={8}
            md={6}
            xs={12}
          >
            <ProfileDetails userInfo={context.userInfo} warehouseUserInfo={context.warehouseUserInfo} context={context}/>
          </Grid>
        </Grid>
      </Container>
    </Page>
    )}</MyContext.Consumer>
  );
};

export default Account;
